<template>
    <div>

        <workday-add ref="workdayAdd" v-if="this.canEdit" :visible.sync="addRecordDialogFormVisible" :filters="filters" @workdayAdded="onWorkdayAdded" @close="addRecordDialogFormVisible = false" />
        <workday-edit ref="workdayEdit" v-if="this.canEdit" :visible.sync="dialogFormVisible" :data="resource" @workdayEdited="onWorkdayEdited" @close="dialogFormVisible = false" />
        <workday-shift-assign ref="workdayShiftAssign" v-if="this.canEdit" :visible.sync="dialogShiftFormVisible" :data="resource" @workdayShiftAssigned="onWorkdayShiftAssigned" @close="dialogShiftFormVisible = false" />

        <filters-form @filtersSubmited="onFiltersSubmited" />

        <el-data-table :resourceUrl="baseUrl" ref="dataTable" :externalFiltersValid="filters.valid || false">
            <!-- @sortChanged="handleSortChange"> -->

            <template slot="tableActions">
                <a :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" @click="downloadReport()"><i class="fa fa-download"></i> Download</a>
                <a v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'riogrande'" :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" @click="downloadPlannedVsRealReport()"><i class="fa fa-download"></i> Download P vs. R</a>
                <a v-if="this.canEdit" slot="top-buttons" class="btn btn-default btn-sm" @click="handleAddRecord"><i class="fa fa-pencil"></i> Agregar registro</a>
            </template>

            <template slot="columns">
                <el-table-column width="30" type="expand">
                    <template slot-scope="scope">
                        <el-row :gutter="20">
                            <el-col :span="12"><div><strong>Registros del Día</strong></div>
                                <table class="details">
                                    <tr v-for="item in scope.row.raw" :key="item.D + item.T">
                                        <td><strong>{{devices_key_value[item.D]}}:&nbsp;</strong></td>
                                        <td>{{item.T}}</td>
                                        <!-- <td v-if="item.I" @click="showRecordPhoto(item.I)" style="cursor: pointer;"><i class="fa fa-camera" aria-hidden="true"></i></td> -->
                                    </tr>
                                </table>
                            </el-col>
                            <el-col :span="12"><div><strong>Registros de la Jornada</strong></div>
                                <table class="details">
                                    <tr v-for="item in scope.row.workday" :key="item.D + item.T">
                                        <td><strong>{{devices_key_value[item.D]}}:&nbsp;</strong></td>
                                        <td style="text-align:right"><span v-if="scope.row.date != item.T.substr(0, 10)">(+1) </span>{{item.T.substr(11)}}</td>
                                    </tr>
                                </table>
                            </el-col>
                        </el-row>
                    </template>
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="employee_company_id_number"
                        width="80"
                        align="right"
                        label="Código">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="employee_name"
                        min-width="100"
                        label="Empleado">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="roster_description"
                        label="Nómina">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="date"
                        width="80"
                        align="center"
                        label="Fecha">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        label="Turno">
                        <template slot-scope="scope">{{ shift_name(scope.row) }}</template>
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        label="Permisos">
                        <template slot-scope="scope">
                            <!-- <div v-for="permission in scope.row.computed.perm" :key="permission.id">
                                {{ permission.C }} ({{ permission.F }}-{{ permission.T }})
                            </div> -->
                            <el-tooltip v-if="scope.row.excuses && scope.row.excuses.filter(Boolean).length" placement="top">
                                <div slot="content">
                                    <div v-html="formatPermissions(scope.row.excuses.filter(Boolean))"></div>
                                </div>
                                <el-button>{{scope.row.excuses.filter(Boolean).length}}</el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        width="80"
                        align="center"
                        label="Entrada">
                        <template slot-scope="scope">{{ (scope.row.computed.in != null) ? scope.row.computed.in : ((scope.row.workday[0] !== undefined && scope.row.workday[0].T != undefined) ? scope.row.workday[0].T.split(' ')[1] : 'Sin registros') }}</template>
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="computed.out"
                        width="80"
                        align="center"
                        label="Salida">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        label="Recargos">
                        <template slot-scope="scope"><div v-for="(val, key) in scope.row.computed.hours" :key="key">{{key}}: {{val}}</div></template>
                    </el-table-column>
                    <!-- <el-table-column xsortable="custom"
                        label="Inconsistencias">
                        <template slot-scope="scope"><el-tag type="danger" size="mini" v-for="inconcistency in scope.row.inconsistencies" :key="inconcistency.type">{{inc_desc[inconcistency.type]}}</el-tag></template>
                    </el-table-column> -->
                    <el-table-column xsortable="custom"
                        prop="computed.late"
                        min-width="80"
                        align="right"
                        header-align="center"
                        label="Entrada tarde (min.)">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        prop="computed.early"
                        min-width="85"
                        align="right"
                        header-align="center"
                        label="Salida temprano (min.)">
                    </el-table-column>
                    <el-table-column xsortable="custom"
                        min-width="85"
                        align="right"
                        header-align="center"
                        label="Total descuento (min.)">
                        <template slot-scope="scope">{{(isNaN(scope.row.computed.late) ? 0 : scope.row.computed.late) + (isNaN(scope.row.computed.early) ? 0 : scope.row.computed.early)}}</template>
                    </el-table-column>
                    <el-table-column
                        v-if="this.canEdit"
                        width="115"
                        label="Editar">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button size="mini" type="primary" icon="el-icon-edit" :plain="true" title="Editar jornada" @click="handleEdit(scope.$index, scope.row)"></el-button>
                                <el-button size="mini" type="primary" icon="el-icon-time" :plain="true" title="Cambiar turno" @click="handleChangeShift(scope.$index, scope.row)"></el-button>
                                <el-button v-if="scope.row.shift_company_id_number !== null" size="mini" type="danger" icon="el-icon-delete" :plain="true" title="Eliminar turno" @click="handleDeleteShift(scope.$index, scope.row)"></el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>

                        <!-- <el-table-column
                            label="Alertas">
            <template slot-scope="scope">
                -
            </template>
            </el-table-column> -->
        </template>
    </el-data-table>


</div>
</template>

<style>
    table.details td {
        padding-left: 3px;
        padding-right: 3px;
        font-size: 11px;
        line-height: 1.3em;
        height: 15px;
    }
    .drop.over {
        border-color: #aaa;
        background: #ccc;
    }
    .drag {
        cursor: grab;
    }
</style>

<script>
    import { mapGetters, mapActions } from "vuex";
    import filters_form from './filters-form.vue';
    import el_data_table from '../el-data-table.vue';
    import workday_edit from './workday-edit.vue';
    import workday_add from './workday-add.vue';
    import workday_shift_assign from './workday-shift-assign.vue';
    import { getOptionLabel } from '../../utils/lib';
    import { Drag, Drop } from 'vue-drag-drop';

    export default {
        data() {
            const canEdit = this.$auth.can(['reports.dailyattendancedetails_edit']);
            return {
                canEdit,
                // devices: {},
                baseUrl: "/reports/dailyattendancedetails",
                // shiftsByFunctionalArea: [],
                // functional_areas: [],
                // shifts: [],
                resource: {
                    // prev_records: null,
                    // records: null,
                    // next_records: null,
                    // start_time: null,
                    // end_time: null,
                    employee: {
                        id: null,
                        company_id_number: null,
                        name: null
                    },
                    shift_id: null,
                    shift: null,
                    date: null,
                    // start_record_date: 'same_day',
                    // end_record_date: 'same_day'
                    computed: null,
                    functional_area_id: null,
                },
                over: false,
                downloadUrl: null,
                orderBy: [],
                dialogFormVisible: false,
                dialogShiftFormVisible: false,
                addRecordDialogFormVisible: false,
                edit: false,
                inc_desc: {
                    MLO: 'Falta S',
                    NUI: 'Múltiples E/S',
                    WIOS: 'Sec. E/S'
                },
                employee_loading: false,
                employees: [],
                employees_from_db: [],
                last_employee_search: null,
                filters: {},
            };
        },
        watch: {
            $route: function(to) {
                this.setDownloadUrl();
            }
        },
        computed: {
            ...mapGetters(["devices_key_value"]),
        },
        mounted() {
            this.setDownloadUrl();
            this.fetchDevices();
        },
        components: {
            'filters-form': filters_form,
            "el-data-table": el_data_table,
            "workday-edit": workday_edit,
            "workday-add": workday_add,
            "workday-shift-assign": workday_shift_assign,
            Drag,
            Drop
        },
        methods: {
            ...mapActions(["fetchFunctionalAreasWithShifts", "fetchDevices"]),
            onFiltersSubmited(filters) {
                // console.log(filters);
                this.filters = filters;
            },
            formatPermissions(excuses) {
                return _.map(excuses, (elem) => elem.description + ' - ' + moment(elem.datetime_from).format('YYYY-MM-DD HH:mm') + ' - ' + moment(elem.datetime_to).format('YYYY-MM-DD HH:mm')).join('<br/>');
            },
            shift_name: function(row) {
                if (row.shift_company_id_number !== null) {
                    return row.shift_company_id_number;
                } else if (!row.computed instanceof Array && row.computed.shift !== null) {
                    return row.computed.shift;
                } else {
                    return null;
                }
            },
            showRecordPhoto: function(imageName) {
                // imageName = 'mobile_record.jpg';
                this.$alert('<img src="https://labortime-express-records.s3.us-east-2.amazonaws.com/' + imageName + '"></img>', 'Imagen del registro', {
                    dangerouslyUseHTMLString: true
                });
            },
            setDownloadUrl: function() {
                // console.log(this.$route);
                this.queryString = $.param(this.$route.query);
                if (
                    this.$route.query.date_from != undefined &&
                    this.$route.query.date_to != undefined &&
                    this.$route.query.date_from != null &&
                    this.$route.query.date_to != null
                ) {
                    this.downloadUrl =
                        "/api" + this.baseUrl + "/download?" + this.queryString;
                } else {
                    this.downloadUrl = null;
                }
            },
            downloadReport: function() {
                if (this.downloadUrl != null) {
                    window.location.href =
                        this.downloadUrl + "&token=" + localStorage.getItem("id_token");
                }
            },
            downloadPlannedVsRealReport: function () {
                if (this.downloadUrl != null) {
                    window.location.href = "/api/reports/plannedvsreality/download?" + this.queryString + "&token=" + localStorage.getItem("id_token");
                }
            },
            handleSortChange(value) {
                // console.log(value);
                let idx = _.findIndex(this.orderBy, elem => {
                    return elem.field === value.prop;
                });
                if (idx > -1) {
                    this.orderBy.splice(idx, 1);
                }
                this.orderBy.unshift({
                    field: value.prop,
                    order: value.order
                });
            },
            handleAddRecord: function() {
                this.$refs['workdayAdd'].addManualRecords();
                this.addRecordDialogFormVisible = true;
            },
            handleEdit: function(index, row) {
                this.resource.employee.id = row.employee_id;
                this.resource.employee.company_id_number = row.employee_company_id_number;
                this.resource.employee.name = row.employee_name;
                this.resource.date = row.date;
                this.resource.computed = row.computed;

                this.$refs['workdayEdit'].handleEdit();
                this.dialogFormVisible = true;
            },
            onWorkdayEdited: function () {
                this.dialogFormVisible = false;
                this.$refs.dataTable.fetchItems();
            },
            onWorkdayAdded: function () {
                this.addRecordDialogFormVisible = false;
                this.$refs.dataTable.fetchItems();
            },
            onWorkdayShiftAssigned: function () {
                this.dialogShiftFormVisible = false;
                this.$refs.dataTable.fetchItems();
            },
            handleChangeShift: function (index, row) {
                // console.log(index);
                if (row.functional_area_id === null) {
                    alert("No puede asignar un turno a un empleado sin área");
                    return;
                }
                this.resource.employee.id = row.employee_id;
                this.resource.employee.company_id_number = row.employee_company_id_number;
                this.resource.employee.name = row.employee_name;
                this.resource.date = row.date;
                this.resource.functional_area_id = row.functional_area_id;
                this.resource.shift = row.computed.shift;

                this.$refs['workdayShiftAssign'].handleEdit();
                this.dialogShiftFormVisible = true;
            },
            handleDeleteShift: function (index, row) {
                if (row.shift_company_id_number === null) {
                    return;
                }
                this.$confirm(
                    '¿Está seguro de que desea eliminar el turno asignado (' + row.shift_company_id_number + ') para el empleado ' + row.employee_name + ' en la fecha ' + row.date + '?',
                    'Confirmar eliminación',
                    {
                        confirmButtonText: 'Eliminar',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }
                ).then(() => {
                    axios
                        .delete('/api/employees/' + row.employee_id + '/shifts?date=' + row.date)
                        .then(response => {
                            this.$message({
                                type: 'success',
                                message: 'Turno eliminado correctamente.'
                            });
                            this.$refs.dataTable.fetchItems();
                        })
                        .catch(error => {
                            let msg = 'Error al eliminar el turno.';
                            if (error.response && error.response.data && error.response.data.message) {
                                msg = error.response.data.message;
                            }
                            this.$message({
                                type: 'error',
                                message: msg
                            });
                        });
                }).catch(() => {});
            },

        }
    };
</script>
